import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchCategoryBasedPapers, resetState, setState } from "./redux/slice";
import moment from "moment";
import Select from "react-select";
import SimpleTable from "./SimpleTable";
import { fetchOrgUsersById } from "../../../pages/user/redux/userThunk";
import userStore from "../../../zustand/userStore";
import { GetClasesThunk, GetSubjectsThunk } from "../createpaper/redux/thunk";
export default function AllPapers() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get("type") === "worksheet" ? "2" : "1";

  const userId = userStore((state) => state.user.id);
  useEffect(() => {
    if (!userId) return;
    dispatch(resetState());
    dispatch(
      fetchCategoryBasedPapers({
        userId,
        type: activeTab,
      }),
    );

    dispatch(fetchOrgUsersById(userId));
  }, [dispatch, activeTab, userId]);

  useEffect(() => {
    if (!params.get("type")) {
      navigate("/allPapers?type=question", { replace: true });
    }
  }, [location.search, navigate]);

  // const styles = useMemo(
  //   () => ({
  //     wrapper: {
  //       display: "flex",
  //       gap: "12px",
  //       borderBottom: "1px solid #e5e7eb",
  //       marginBottom: "16px",
  //     },
  //     tab: {
  //       padding: "10px 18px",
  //       border: "none",
  //       borderRadius: "8px 8px 0 0",
  //       cursor: "pointer",
  //       fontWeight: 500,
  //       backgroundColor: "#f1f5f9",
  //       color: "#475569",
  //     },
  //     active: {
  //       backgroundColor: "#2563eb",
  //       color: "#ffffff",
  //     },
  //   }),
  //   [],
  // );
  const styles = useMemo(
    () => ({
      wrapper: {
        display: "flex",
        gap: "12px",
        borderBottom: "1px solid #e5e7eb",
        marginBottom: "16px",
      },
      tab: {
        padding: "10px 18px",
        border: "none",
        borderRadius: "8px 8px 0 0",
        cursor: "pointer",
        fontWeight: 500,
        // backgroundColor: "#2563eb",
        backgroundColor: "#f1f5f9",
        // color: "#ffffff",
        color: "#2563eb",
        border: "1px solid #2563eb",
      },
      active: {
        // backgroundColor: "#f1f5f9",
        backgroundColor: "#2563eb",
        // color: "#2563eb",
        // border: "1px solid #2563eb",
        color: "#ffffff",
      },
    }),
    [],
  );
  const handleTabs = (value, tab) => {
    navigate(`/allPapers?type=${value}`);
    dispatch(resetState());
    dispatch(
      fetchCategoryBasedPapers({
        userId,
        type: tab || activeTab,
      }),
    );
  };

  return (
    <div className="container_bg container-fluid w-100 mx-auto font-inter">
      <div className="row mx-auto w-100 px-5 py-3">
        <div className="col-md-12" style={styles.wrapper}>
          <button
            style={{ ...styles.tab, ...(activeTab === "1" && styles.active) }}
            onClick={() => handleTabs("question", 1)}
          >
            All Question Papers
          </button>

          <button
            style={{ ...styles.tab, ...(activeTab === "2" && styles.active) }}
            // onClick={() => {
            //   navigate("/allPapers?type=worksheet");
            //   dispatch(resetState());
            //   dispatch(
            //     fetchCategoryBasedPapers({
            //       userId,
            //       type: activeTab,
            //     }),
            //   );
            // }}
            onClick={() => handleTabs("worksheet", 2)}
          >
            All Worksheets
          </button>
        </div>

        {activeTab === "1" && <ViewQuestionPaper />}
        {activeTab === "2" && <ViewWorkSheets />}
      </div>
    </div>
  );
}

export function ViewQuestionPaper() {
  return (
    <div>
      <PaperTable title="View Question Papers" />
    </div>
  );
}

export function ViewWorkSheets() {
  return (
    <div>
      <PaperTable title="View Worksheets" />
    </div>
  );
}

const safeParse = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return {};
  }
};

function PaperTable({ title }) {
  const { categoryBasedData, userName, createdAt, class_id, subject_id } =
    useSelector((state) => state.allPapers);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();
  const { users } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const columns = useMemo(
    () => [
      { Header: "Sl No.", accessor: "sno" },
      { Header: "User Name", accessor: "username" },
      { Header: "Exam Name", accessor: "examName" },
      { Header: "Subject", accessor: "subjectName" },
      { Header: "Class", accessor: "className" },
      { Header: "Max Marks", accessor: "maxMarks" },
      { Header: "Created At", accessor: "createdAt" },
      { Header: "Actions", accessor: "action" },
    ],
    [],
  );

  useEffect(() => {
    const records = categoryBasedData?.records || [];

    if (records.length) {
      const mappedData = records.map((item, index) => {
        const formData = safeParse(item.form_data);

        return {
          sno: index + 1,
          id: item.id,
          username: item.username,
          examName: formData?.examName,
          subjectName: formData?.subjectName,
          className: formData?.className,
          maxMarks: formData?.maxMarks,
          rawCreated_at: item.created_at,
          createdAt: moment(item.created_at).local().format("DD-MM-YY h:mm A"),
          // item.created_at +
          // "-" +
          // moment(item.created_at).format("DD-MM-YY h:mm A"),
          action: (
            <i
              className="fas fa-eye blue-icon"
              onClick={(e) => {
                e.preventDefault();
                navigate("/createPaper", {
                  state: { paperId: item.id, type: 1 },
                });
              }}
            />
          ),
        };
      });

      setFilteredData(mappedData);
    } else {
      setFilteredData([]);
    }
  }, [categoryBasedData?.records, navigate]);

  // const data = useMemo(() => {
  //   const records = categoryBasedData?.records || [];

  //   // 🚨 No search → show all
  //   if (!searchTriggered) {
  //     return records.map((item, index) => {
  //       const formData = safeParse(item.form_data);

  //       return {
  //         sno: index + 1,
  //         id: item.id,
  //         username: item.username,
  //         examName: formData?.examName,
  //         subjectName: formData?.subjectName,
  //         className: formData?.className,
  //         maxMarks: formData?.maxMarks,
  //         createdAt: moment(item.created_at).format("DD-MM-YY HH:mm A"),
  //         action: (
  //           <i
  //             className="fas fa-eye blue-icon"
  //             onClick={(e) => {
  //               e.preventDefault();
  //               navigate("/createPaper", {
  //                 state: { paperId: item.id, type: 1 },
  //               });
  //             }}
  //           />
  //         ),
  //       };
  //     });
  //   }

  //   // ✅ USE SNAPSHOT FILTERS ONLY
  //   const { userName, createdAt, class_id, subject_id } = appliedFilters;

  //   const filteredRecords = records.filter((item) => {
  //     const formData = safeParse(item.form_data);
  //     const conditions = [];

  //     if (userName) {
  //       conditions.push(String(item.created_by) === String(userName));
  //     }

  //     if (createdAt) {
  //       conditions.push(
  //         moment(item.created_at).isSame(moment(createdAt), "minute"),
  //       );
  //     }

  //     if (class_id) {
  //       conditions.push(String(formData?.class) === String(class_id));
  //     }

  //     if (subject_id) {
  //       conditions.push(String(formData?.subject) === String(subject_id));
  //     }

  //     return conditions.every(Boolean);
  //   });

  //   return filteredRecords.map((item, index) => {
  //     const formData = safeParse(item.form_data);

  //     return {
  //       sno: index + 1,
  //       id: item.id,
  //       username: item.username,
  //       examName: formData?.examName,
  //       subjectName: formData?.subjectName,
  //       className: formData?.className,
  //       maxMarks: formData?.maxMarks,
  //       createdAt: moment(item.created_at).format("DD-MM-YY HH:mm A"),
  //       action: (
  //         <i
  //           className="fas fa-eye blue-icon"
  //           onClick={(e) => {
  //             e.preventDefault();
  //             navigate("/createPaper", {
  //               state: { paperId: item.id, type: 1 },
  //             });
  //           }}
  //         />
  //       ),
  //     };
  //   });
  // }, [
  //   categoryBasedData?.records,
  //   searchTriggered,
  //   appliedFilters, // ✅ IMPORTANT
  //   navigate,
  // ]);
  // useEffect(() => {
  //   if (userName || createdAt || class_id || subject_id) {
  //
  //   }
  // }, [userName, createdAt, class_id, subject_id, dispatch]);

  // const userOptions = useMemo(() => {
  //   return (
  //     users
  //       ?.slice()
  //       .sort((a, b) => a.name.localeCompare(b.name))
  //       .map((u) => ({
  //         value: u.id,
  //         label: u.name,
  //       })) || []
  //   );
  // }, [users]);
  const { classes, subjects } = useSelector((store) => store.createQstnPaper);
  useEffect(() => {
    dispatch(GetClasesThunk());
  }, [dispatch]);
  useEffect(() => {
    if (class_id) dispatch(GetSubjectsThunk({ classId: Number(class_id) }));
  }, [dispatch, class_id]);
  // const opt = 2;
  // const opt = 1;
  // const [filterBy, setFilterBy] = useState("");

  return (
    <div>
      <h5 style={{ fontSize: "18px" }}>{title}</h5>

      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          gap: "16px",
          flexWrap: "wrap", // ✅ allow wrap
        }}
      >
        {/* Username */}
        <div
          style={{ display: "flex", flexDirection: "column", width: "200px" }}
        >
          <label style={{ fontSize: "14px", marginBottom: "4px" }}>
            <strong>Username</strong>
          </label>
          <Select
            options={
              users?.length > 0
                ? [...users] // make a shallow copy
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((u) => ({ value: u.id, label: u.name }))
                : []
            }
            // }
            // users
            //   ?.sort((a, b) => a.name.localeCompare(b.name))
            //   .map((u) => ({ value: u.id, label: u.name })) || []
            value={
              users?.find((u) => u.id === userName)
                ? {
                    value: userName,
                    label: users.find((u) => u.id === userName)?.name,
                  }
                : null
            }
            isSearchable
            defaultInputValue=""
            onChange={(selectedOption) => {
              dispatch(
                setState({
                  key: "userName",
                  value: selectedOption?.value || "",
                }),
              );
            }}
            isClearable
            placeholder="Select"
            styles={{
              container: (base) => ({ ...base, width: "200px" }),
              control: (base) => ({
                ...base,
                minHeight: "32px",
                height: "40px",
                fontSize: "16px",
              }),
              valueContainer: (base) => ({
                ...base,
                height: "40px",
                padding: "0 8px",
              }),
              indicatorsContainer: (base) => ({ ...base, height: "32px" }),
              dropdownIndicator: (base) => ({ ...base, padding: "4px" }),
              clearIndicator: (base) => ({ ...base, padding: "4px" }),
            }}
          />

          {false && (
            <select
              value={userName}
              onChange={(e) => {
                dispatch(setState({ key: "userName", value: e.target.value }));
              }}
              style={{
                height: "40px",
                fontSize: "14px",
                padding: "4px 6px",
                borderRadius: "4px",
                // width: "100px",
              }}
            >
              <option value="">Select</option>
              {users?.map((u) => (
                <option key={u.id} value={u.id}>
                  {u.name}
                </option>
              ))}
            </select>
          )}
        </div>
        {/* Date */}
        <div
          style={{ display: "flex", flexDirection: "column", width: "180px" }}
        >
          <label style={{ fontSize: "14px", marginBottom: "4px" }}>
            <strong>Date</strong>
          </label>
          <input
            type="datetime-local"
            value={createdAt ? createdAt.slice(0, 16) : ""}
            onChange={(e) => {
              dispatch(setState({ key: "createdAt", value: e.target.value }));
              // const rawValue = e.target.value || null; // 2026-01-16T16:27

              // const formattedValue =
              //   rawValue && moment(rawValue).format("DD-MM-YY h:mm A");

              // dispatch(setState({ key: "createdAt", value: formattedValue }));
            }}
            style={{
              height: "40px",
              fontSize: "14px",
              padding: "4px 6px",
              borderRadius: "4px",
            }}
          />
        </div>
        {/* Class */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            // width: "160px",
            width: "200px",
            // marginRight: "24px",
          }}
        >
          <label style={{ fontSize: "14px", marginBottom: "4px" }}>
            <strong>Class</strong>
          </label>
          <Select
            options={classes}
            isClearable
            value={classes.find((c) => c.value === class_id) || null}
            onChange={(e) => {
              dispatch(setState({ key: "class_id", value: e?.value || "" }));
              dispatch(setState({ key: "subject_id", value: "" }));
            }}
            placeholder="Select"
            styles={{
              container: (base) => ({
                ...base,
                width: "200px", // ✅ increase width
              }),
              control: (base) => ({
                ...base,
                minHeight: "32px", // ✅ reduce height
                height: "40px",
                fontSize: "16px",
              }),
              valueContainer: (base) => ({
                ...base,
                height: "40px",
                padding: "0 8px",
              }),
              indicatorsContainer: (base) => ({
                ...base,
                height: "32px",
              }),
              dropdownIndicator: (base) => ({
                ...base,
                padding: "4px",
              }),
              clearIndicator: (base) => ({
                ...base,
                padding: "4px",
              }),
            }}
          />
        </div>

        {/* Subject */}
        <div
          style={{ display: "flex", flexDirection: "column", width: "200px" }}
        >
          <label style={{ fontSize: "14px", marginBottom: "4px" }}>
            <strong>Subject</strong>
          </label>
          <Select
            options={subjects}
            isClearable
            value={subjects.find((s) => s.value === subject_id) || null}
            onChange={(e) => {
              dispatch(setState({ key: "subject_id", value: e?.value || "" }));
            }}
            styles={{
              container: (base) => ({
                ...base,
                width: "200px", // ✅ increase width
              }),
              control: (base) => ({
                ...base,
                minHeight: "32px", // ✅ reduce height
                height: "40px",
                fontSize: "16px",
              }),
              valueContainer: (base) => ({
                ...base,
                height: "40px",
                padding: "0 8px",
              }),
              indicatorsContainer: (base) => ({
                ...base,
                height: "32px",
              }),
              dropdownIndicator: (base) => ({
                ...base,
                padding: "4px",
              }),
              clearIndicator: (base) => ({
                ...base,
                padding: "4px",
              }),
            }}
            placeholder="Select"
          />
        </div>
        {(userName || createdAt || class_id || subject_id) && (
          <button
            style={{
              height: "40px",
              padding: "0 16px",
              fontSize: "14px",
              fontWeight: 500,
              borderRadius: "6px",
              border: "1px solid #2563eb",
              backgroundColor: "#2563eb",
              color: "#fff",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#1e40af")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#2563eb")}
            onClick={() => {
              // 1️⃣ Save snapshot filters
              // dispatch(
              //   setState({
              //     key: "appliedFilters",
              //     value: { userName, createdAt, class_id, subject_id },
              //   }),
              // );
              dispatch(setState({ key: "searchTriggered", value: true }));

              // 2️⃣ Filter RAW records
              const records = categoryBasedData?.records || [];

              const filteredRecords = records.filter((item) => {
                const formData = safeParse(item.form_data);
                const conditions = [];

                if (userName) {
                  conditions.push(String(item.created_by) === String(userName));
                }

                if (createdAt) {
                  const formattedInput =
                    moment(createdAt).format("DD-MM-YY h:mm A");
                  const formattedApi = moment(item.created_at).format(
                    "DD-MM-YY h:mm A",
                  ); // same format
                  conditions.push(formattedApi === formattedInput);
                  // const formattedValue =
                  //   createdAt && moment(createdAt).format("DD-MM-YY h:mm A");
                  // conditions.push(
                  //   String(item?.createdAt) === String(formattedValue),
                  // );

                  // conditions.push(
                  //   // moment(item.created_at).isSame(moment(createdAt), "minute"),
                  //   moment(item.rawCreated_at).isSame(
                  //     moment(createdAt),
                  //     "minute",
                  //   ),
                  // );
                }

                if (class_id) {
                  conditions.push(String(formData?.class) === String(class_id));
                }

                if (subject_id) {
                  conditions.push(
                    String(formData?.subject) === String(subject_id),
                  );
                }

                return conditions.every(Boolean);
              });

              // 3️⃣ Map for table
              const mappedData = filteredRecords.map((item, index) => {
                const formData = safeParse(item.form_data);

                return {
                  sno: index + 1,
                  id: item.id,
                  username: item.username,
                  examName: formData?.examName,
                  subjectName: formData?.subjectName,
                  className: formData?.className,
                  maxMarks: formData?.maxMarks,
                  // createdAt: moment(item.created_at)
                  //   .local()
                  //   .format("DD-MM-YY HH:mm A"),
                  createdAt: moment(item.created_at)
                    .local() // convert UTC to local time
                    .format("DD-MM-YY h:mm A"),

                  action: (
                    <i
                      className="fas fa-eye blue-icon"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/createPaper", {
                          state: { paperId: item.id, type: 1 },
                        });
                      }}
                    />
                  ),
                };
              });

              // 4️⃣ Update table
              setFilteredData(mappedData);
            }}
          >
            Search
          </button>
        )}
      </div>

      <br />
      <SimpleTable columns={columns} data={filteredData} isCustomSearch />
    </div>
  );
}
